"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function ImportSpreadsheet32Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 32, height: 33, viewBox: "0 0 32 33", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.1363 0C9.71599 0 9.37524 0.340741 9.37524 0.761068V27.2389C9.37524 27.6593 9.71599 28 10.1363 28H31.2353C31.6556 28 31.9963 27.6593 31.9963 27.2389V6.6457L24.7971 0L10.1363 0Z", fill: "#659675" }),
        react_1.default.createElement("rect", { x: 14.5627, y: 13.125, width: 12.25, height: 8.75, stroke: "white", strokeWidth: 1.75 }),
        react_1.default.createElement("path", { d: "M13.6877 17.5L27.6877 17.5", stroke: "white", strokeWidth: 1.75 }),
        react_1.default.createElement("path", { d: "M20.6877 12.25L20.6877 22.75", stroke: "white", strokeWidth: 1.75 }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.9997 6.63281V6.63237L24.7996 0L24.7974 0V6.18933C24.7974 6.43426 24.9959 6.63281 25.2408 6.63281H31.9997Z", fill: "black" }),
        react_1.default.createElement("ellipse", { cx: 8.1106, cy: 24.1, rx: 8.09986, ry: 8.1, fill: "#5E30E3" }),
        react_1.default.createElement("path", { d: "M8.36133 28.0176L8.36133 20.1789", stroke: "white", strokeWidth: 1.37143 }),
        react_1.default.createElement("path", { d: "M8.01895 20.1738C8.01895 21.5546 6.88888 24.3162 4.70508 24.3162", stroke: "white", strokeWidth: 1.37143, strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M8.70508 20.1738C8.70508 21.5546 9.83515 24.3162 12.0189 24.3162", stroke: "white", strokeWidth: 1.37143, strokeLinejoin: "round" }));
}
function ImportSpreadsheet32(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(ImportSpreadsheet32Svg, Object.assign({}, svgProps)));
}
exports.default = ImportSpreadsheet32;
//# sourceMappingURL=ImportSpreadsheet32.js.map